(function () {
  var root = document.querySelector(".qpr");
  if (!root) return;

  var chips = root.querySelectorAll(".qpr__chip");
  var cards = Array.prototype.slice.call(root.querySelectorAll(".qpr-card"));
  var more = root.querySelector(".qpr__more");
  var empty = root.querySelector(".qpr__empty");
  var PAGE = 4;
  var tag = "all";
  var shown = PAGE;

  function isPin(card) {
    return card.getAttribute("data-pinned") === "true";
  }

  function match(card) {
    if (isPin(card)) return true;
    return tag === "all" || card.getAttribute("data-tag") === tag;
  }

  function paint() {
    var rest = cards.filter(function (card) {
      return !isPin(card) && match(card);
    });
    cards.forEach(function (card) {
      if (isPin(card)) {
        card.classList.remove("is-out");
        return;
      }
      card.classList.toggle("is-out", !match(card) || rest.indexOf(card) >= shown);
    });
    var visible = rest.length;
    if (empty) empty.hidden = visible + cards.filter(isPin).length > 0;
    if (more) more.hidden = shown >= visible;
  }

  chips.forEach(function (chip) {
    chip.addEventListener("click", function () {
      tag = chip.getAttribute("data-filter") || "all";
      shown = PAGE;
      chips.forEach(function (c) {
        var on = c === chip;
        c.classList.toggle("is-on", on);
        c.setAttribute("aria-pressed", on ? "true" : "false");
      });
      paint();
    });
  });

  if (more) {
    more.addEventListener("click", function () {
      shown += PAGE;
      paint();
    });
  }

  paint();

  var lb = root.querySelector(".qpr-lb");
  var lbImg = lb ? lb.querySelector("img") : null;
  var lbClose = lb ? lb.querySelector(".qpr-lb__close") : null;

  function closeLb() {
    if (!lb || !lb.open) return;
    lb.close();
  }

  root.addEventListener("click", function (e) {
    var btn = e.target.closest(".qpr-card__photo");
    if (!btn || !lb || !lbImg) return;
    var src = btn.getAttribute("data-full");
    if (!src) return;
    lbImg.src = src;
    if (typeof lb.showModal === "function") lb.showModal();
  });

  if (lbClose) lbClose.addEventListener("click", closeLb);
  if (lb) {
    lb.addEventListener("click", function (e) {
      if (e.target === lb) closeLb();
    });
  }
})();
